import React, { useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../../../core/helpers/isMobile';

import { winBarStore } from '../../../../../store/winBarStore';
import { userInfoStore } from '../../../../../store/userInfoStore';
import { applicationStore } from '../../../../../store/applicationStore';

import TextOrderingByWidth from '../../../textOrderingByWidth';
import { isoStandard } from '../../../../../core/helpers/isoStandard';

const FreeBetTotalWin = observer(() => {
  const freeBetTotalWinRef = useRef(null);
  const { currencyIcon, currencySymbol } = userInfoStore;
  const { totalWinAmount } = winBarStore;
  const { isShowLicenseMode, isDemo } = applicationStore;
  const {
    canvasTranslationKeys: { TOTAL_WIN },
  } = applicationStore;

  const texts = useMemo(() => {
    return [
      {
        id: 0,
        text: TOTAL_WIN,
        style: { fill: '#FFC33E', _fontWeight: 700, _fontSize: isMobile() ? 20 : 24 },
        ref: null,
      },
      {
        id: 1,
        text: isoStandard(totalWinAmount, true),
        style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 24 : 30 },
        ref: freeBetTotalWinRef,
      },
      {
        id: 2,
        text: isShowLicenseMode && !isDemo ? currencyIcon : currencySymbol,
        style: { fill: '#FFFFFF', _fontWeight: 700, _fontSize: isMobile() ? 20 : 24 },
        ref: null,
      },
    ];
  }, [isDemo, currencyIcon, TOTAL_WIN, currencySymbol, totalWinAmount, isShowLicenseMode]);

  const updateTextByLicense = useMemo(() => {
    return isShowLicenseMode && !isDemo ? [texts[0], texts[2], texts[1]] : texts;
  }, [isShowLicenseMode, isDemo, texts]);

  return <TextOrderingByWidth texts={updateTextByLicense} />;
});

export default FreeBetTotalWin;
